import { registerApp, getWindow } from '../../utils.js';
const appId = 'pricingservice';
// eslint-disable-next-line no-unused-vars
let host = null;
const browserWindow = getWindow(appId);
window.emui = window.emui || { uuid: crypto.randomUUID() };

const createPageLayout = () => {
  const bodyEle = document.body;
  bodyEle.innerHTML = `<main>
    <h3 class="text-lg font-medium leading-6 text-gray-900">
      Mortgage Pricing
    </h3>
    <div class="mt-5 bg-orange-100 shadow sm:rounded-lg">
      <div class="px-4 py-5 sm:px-6">
        <h3 class="text-lg font-medium leading-6 text-gray-900">
          Average Rates
        </h3>
        <p class="mt-1 max-w-2xl text-sm text-gray-500">
          for $<span id="loanAmount"></span>; Term:
          <span id="term"></span> years; Down Payment: $<span
            id="downPayment"
          ></span>
        </p>
      </div>
      <div class="border-t border-gray-200">
        <dl>
          <div
            class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm font-medium text-gray-500">30-yr fixed</dt>
            <dd
              id="30yearRate"
              class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
            >
              7.01%
            </dd>
          </div>
          <div
            class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm font-medium text-gray-500">15-yr fixed</dt>
            <dd
              id="15yearRate"
              class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
            >
              5.61%
            </dd>
          </div>
          <div
            class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm font-medium text-gray-500">10/6 ARM</dt>
            <dd
              id="106ARMRate"
              class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
            >
              6.42%
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </main>`;
};

window.emui.app = {
  uuid: window.emui.uuid,
  init: async (options) => {
    host = options.host;
    return Promise.resolve();
  },
  mount: async (options) => {
    createPageLayout();
    const loanAmountElement = document.getElementById('loanAmount');
    const termElement = document.getElementById('term');
    const downPaymentElement = document.getElementById('downPayment');
    const loanObj = await host.getObject('Loan');
    const { amount, term, downPayment } = await loanObj.getLoanDetails();
    loanAmountElement.innerText = Intl.NumberFormat().format(amount);
    termElement.innerText = term;
    downPaymentElement.innerText = Intl.NumberFormat().format(downPayment);
    // subscribe to scripting object events
    host.subscribe({
      eventId: loanObj.onLoanAmountChanged.id,
      callback: ({ eventParams: { amount } }) => {
        loanAmountElement.innerText = amount;
      },
    });
    host.subscribe({
      eventId: loanObj.onLoanTermChanged.id,
      callback: ({ eventParams: { term } }) => {
        termElement.innerText = term;
      },
    });
    host.subscribe({
      eventId: loanObj.onDownPaymentChanged.id,
      callback: ({ eventParams: { downPayment } }) => {
        downPaymentElement.innerText = downPayment;
      },
    });
    return Promise.resolve();
  },
  unmount: async (options) => Promise.resolve(),
};

registerApp({ browserWindow, appId, app: window.emui.app });